import { Component, OnDestroy, OnInit } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { TutorialService } from 'src/app/service/tutorial-service/tutorial.service';

@Component({
  selector: 'app-tutorial-list',
  templateUrl: './tutorial-list.component.html',
  styleUrls: ['./tutorial-list.component.css']
})
export class TutorialListComponent implements OnInit, OnDestroy {
  search: string = '';
  selectedStatus: boolean = true;
  currentPage = 1;
  totalPages = 0;
  totalResults = 0;
  tutorialsList: any[] = [];
  filtertutorialsList: any[] = [];
  tutorialModalObj: any;
  user: any;

  constructor(
    private tutorialService: TutorialService,
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit(): void {
    this.getTutorials(this.currentPage);
  }

  getTutorials(page: number) {
    const queryparams: any = {
      page,
      limit: 9999,
      isActive: this.selectedStatus,
      audience: 'provider-fundingsource'
    };

    if (this.search.trim()) {
      queryparams.search = this.search.trim();
    }

    this.tutorialService.getTutorials(queryparams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (res: any) => {
          this.tutorialsList = res.results || [];
          this.filtertutorialsList = res.results || [];
          this.totalPages = res.totalPages || 0;
          this.totalResults = res.totalResults || 0;
        },
        (error) => {
          this.clearTutorials();
        }
      );
  }

  clearTutorials() {
    this.tutorialsList = [];
    this.filtertutorialsList = [];
    this.totalPages = 0;
    this.totalResults = 0;
  }

  onSelectStatus() {
    this.currentPage = 1;
    this.getTutorials(this.currentPage);
  }

  ngOnDestroy(): void { }
}
